import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Text.css';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';

const TxtWeightSnipp = () => {
  const TxtWeightSnippRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const tCopySnippet = () => {
    if (TxtWeightSnippRef.current) {
      const range = document.createRange();
      range.selectNode(TxtWeightSnippRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  const hSnippetRef = useRef(null);
  const [TxtAlignScan, hSetShowScanning] = useState(false);

  const tWCopySnippet = () => {
    if (hSnippetRef.current) {
      const range = document.createRange();
      range.selectNode(hSnippetRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      hSetShowScanning(true);
      setTimeout(() => hSetShowScanning(false), 1000);
    }
  };

  return (
    <>
      <pre>
        <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

          <div className='snippet' ref={TxtWeightSnippRef}>
            <code>
              <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-text-density-tiny</span><span className='cln'>"</span><span className='cn'>&gt;</span>
              font-weight: 400;
              <span className='cn'>&lt;/div&gt;</span><br></br><br></br>

              <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-text-density-norm</span><span className='cln'>"</span><span className='cn'>&gt;</span>
              font-weight: 600;
              <span className='cn'>&lt;/div&gt;</span><br></br><br></br>

              <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-text-density-hefty</span><span className='cln'>"</span><span className='cn'>&gt;</span>
              font-weight: 900;
              <span className='cn'>&lt;/div&gt;</span><br></br><br></br>
            </code>

          </div>
          <button aria-label="Copy Button" onClick={tCopySnippet}>
            <Copy />
          </button>
        </div>
        <div className={`center-container ${TxtAlignScan ? 'scanning' : ''}`}>

          <div className='snippet' ref={hSnippetRef}>
            <code>
              <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-text-start</span><span className='cln'>"</span><span className='cn'>&gt;</span>
              text-align: start;
              <span className='cn'>&lt;/div&gt;</span><br></br><br></br>

              <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-text-end</span><span className='cln'>"</span><span className='cn'>&gt;</span>
              text-align: end;
              <span className='cn'>&lt;/div&gt;</span><br></br><br></br>

              <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-text-middle</span><span className='cln'>"</span><span className='cn'>&gt;</span>
              text-align: center;
              <span className='cn'>&lt;/div&gt;</span><br></br><br></br>

              <span className='cn'>&lt;div</span><span className='cln'> class="</span><span className='cn'>carve-text-justify</span><span className='cln'>"</span><span className='cn'>&gt;</span>
              text-align: justify;
              <span className='cn'>&lt;/div&gt;</span><br></br><br></br>
            </code>

          </div>
          <button aria-label="Copy Button" onClick={tWCopySnippet}>
            <Copy />
          </button>
        </div>
      </pre>
    </>
  );
}

const Text = () => {

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Card
        CardTitle='Text'
        CardBody={<TxtWeightSnipp />}
      />
    </motion.div>
  );
}

Text.propTypes = {};

export default Text;
